const map = {
	"./1.png": 282,
	"./10.png": 704,
	"./11.png": 457,
	"./12.png": 450,
	"./13.png": 107,
	"./14.png": 116,
	"./15.png": 245,
	"./16.png": 830,
	"./17.png": 575,
	"./18.png": 920,
	"./19.png": 633,
	"./2.png": 265,
	"./20.png": 813,
	"./21.png": 548,
	"./22.png": 551,
	"./23.png": 710,
	"./24.png": 801,
	"./25.png": 936,
	"./26.png": 795,
	"./27.png": 690,
	"./28.png": 469,
	"./29.png": 572,
	"./3.png": 648,
	"./30.png": 538,
	"./31.png": 451,
	"./32.png": 840,
	"./33.png": 969,
	"./34.png": 486,
	"./35.png": 983,
	"./36.png": 52,
	"./4.png": 167,
	"./5.png": 150,
	"./6.png": 949,
	"./7.png": 532,
	"./8.png": 131,
	"./9.png": 2
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 160;